import React from 'react';
import styled from 'styled-components';

import { useContractContext, useStrings } from 'src/providers';

import { StyledVerticalOption } from 'src/components/Prompts/Vertical/StyledVertical';
import { useCurrencyFormatter } from 'src/hooks/useCurrencyFormatter';

import { FormattedString } from 'src/components/Shared/FormattedString';

import { OptionInputStyles, OptionInputTypes } from 'src/types/IOptions';

const StyledContractSelector = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
`;

interface IContractSelectorProps {
  className?: string;
}

export function ContractSelector(props: IContractSelectorProps) {
  const formatCurrency = useCurrencyFormatter();
  const { className } = props;
  const { contracts, selectedContractId, selectContract } = useContractContext();
  const { termLabel } = useStrings();

  return (
    <StyledContractSelector className={className} data-test="contract-selector">
      {contracts.map((contract) => (
        <StyledVerticalOption
          contractId={contract.id}
          inputStyle={OptionInputStyles.HIDDEN}
          inputType={OptionInputTypes.CHECKBOX}
          isSelected={selectedContractId === contract.id}
          key={contract.id}
          onChange={selectContract}
        >
          <FormattedString
            className='text'
            string={termLabel}
            tagName='span'
            values={{
              term: contract.term,
              termSingular: contract.termLabelSingular,
            }}
          />
          <span className="price">
            +
            {formatCurrency(+contract.price)}
          </span>
        </StyledVerticalOption>
      ))}

    </StyledContractSelector>
  );
}
